import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  checkedItems: []
};

const checkboxSlice = createSlice({
  name: 'checkbox',
  initialState,
  reducers: {
    toggleCheckbox: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        state.checkedItems = state.checkedItems.filter((itemId) => itemId !== id);
      } else {
        state.checkedItems.push(id);
      }
    },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
  },
});

export const { toggleCheckbox, setCheckedItems } = checkboxSlice.actions;

export const selectCheckedItems = (state) => state.checkbox.checkedItems;

export default checkboxSlice.reducer;
